import { Helmet } from "react-helmet";
// import { Element } from 'react-scroll';
import { useImages } from '../general/ImageProvider';

// Components
import { ImageProvider } from "../general/ImageProvider";
import Navbar from "../general/Navbar";
import HomeHero from "./HomeHero";
import HomeOverview from "./HomeOverview";
import ToolsSection from "./ToolsSection";



function Home() {
  const images = useImages();

  if (!Array.isArray(images) || !images.length) {
    return <div></div>;
  }

  // Fetch specific images by their titles (currently unused but logic kept for structure if needed later, or commented out)
  // const maincontent = getImageByTitle('Home Tabs Section') || {};
  // const secIcon = getImageByTitle('sec-icon') || {};



  return (
    <>
      <Helmet>
        <title>Panacea - All-in-One Digital Tools Platform </title>
        <meta name="description" content="Simplify your workflow with Panacea’s free online tools. Easily transform text, beautify code, and optimize images — all in one intuitive platform." />
      </Helmet>

      <ImageProvider>

        {/* Mobile Header */}
        <div className="global-header" >
          <Navbar navtitle="Home" texttitle="Text & Code Gizmo"  insighttitle="Insight" contacttitle="Contact Us" />
        </div>

        {/* Desktop Header */}
        {/* <NavbarHome /> */}

        {/* Main Content */}

        <div className="page-slide">

          {/* About Section  */}
          
            <HomeHero />
          
          {/* About Section  */}

          <HomeOverview />



          <ToolsSection />





          {/* Tabs Section */}

        </div>


      </ImageProvider>

    </>
  );
};



export default Home;
